import React, { useState, useEffect } from 'react';
import './Header.css'
import logo from"../../royal.png";


function Header() {

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 700);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 700);
      if (window.innerWidth >= 700) {
        setIsDrawerOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };


  return (
   <div className="header">
    <img src={logo} />
    {isMobileView && <a href="tel:8882797698" className='phone'>8882797698</a>}
    <div className="option"> 
    {isMobileView && (
        <div className="menu-icon" onClick={toggleDrawer}>
          
          <i className={isDrawerOpen ? "fas fa-times" : "fas fa-bars"}></i>
          
        </div>
      )}
    {(isDrawerOpen || !isMobileView) && (
        <div className="drawer-menu">
          <a href="/">Home</a>
          <a href="/about">About</a>
          <a href="/contact">Contact</a>
          {!isMobileView && <a href="tel:8882797698" className='phone'>8882797698</a>}
        </div>
      )}
      </div>
   </div>
  )
}

export default Header;